export default __webpack_public_path__ + "static/media/move_ITEM_to_LOADPOINT.ea1513bd.svg";